// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cT","homeContent__bottom":"c-i_cU","homeContent__cardHolder":"c-i_cV","homeContent__seoTextHolder":"c-i_cW"};